import "slick-carousel";

import "slick-carousel/slick/slick.css";

$(document).ready(() => {
  $("#boat-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false
  });
});
